<template>
  <div class="hot-article_hot colorBorder">
    <div class="hot-article_hot-title">热门文章</div>
    <div class="hot-article_hot-list">
      <div class="hot-article_hot-list-row" v-for="item in hotArticles" :key="item.id">
        <div class="hot-article_hot-list-row-dot">·</div>
        <div class="hot-article_hot-list-row-text" @click="routeToDetail(item.id)">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      overArticleId: '-1'
    }
  },
  computed: {
    hotArticles() {
      return this.$store.state.statisticInfo.forumPostsDTOList
    }
  },
  methods: {
    // 跳转详情
    routeToDetail(id) {
      window.open(`/poros-community/article-detail/${id}`)
      // this.$router.push(`/article-detail/${id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.colorBorder {
  background: #fff;
  border: 1px solid rgba(229,230,233,1);
}
.hot-article {
  &_hot {
    margin-top: 10px;
    min-height: 70px;
    padding: 0 20px 20px 20px;
    &-title {
      margin: 12px 0;
      font-size: 16px;
      color: #040C2C;
      line-height: 24px;
      font-weight: 600;
    }
    &-list {
      &-row {
        display:flex;
        align-items:center;
        margin-bottom: 10px;
        &-dot {
          flex: 0 0 10px;
          font-size: 20px;
          line-height: 18px;
          margin-right: 2px;
          text-align: center;
        }
        &-text {
          cursor: pointer;
          font-size: 12px;
          color: #040C2C;
          line-height: 18px;
          font-weight: 400;
          overflow: hidden;   
          text-overflow:ellipsis;    
          white-space: nowrap;
          &:hover {
            color: #1740DC;
          }
        }
      }
    }
  }
}
</style>